export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    width: 80,
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('INDEX.table_label_displaySkuName') || '产品名称',
    field: 'displaySkuName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySkuName' },
  },
  {
    title: that.$l('INDEX.table_label_displayBrand') || '品牌名称',
    field: 'brandName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBrand' },
  },
  {
    title: that.$l('INDEX.table_label_displayStore') || '售卖店铺',
    field: 'amzStoreName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayStore' },
  },
  {
    title: that.$l('INDEX.table_label_displaySalesTitle') || '店铺售卖标题',
    field: 'amzStoreName',
    minWidth: 450,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySalesTitle' },
  },
  {
    title: that.$l('INDEX.table_label_ftyPrice') || '工厂单价(rmb)',
    field: 'ftyPrice',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_displayFty') || 'FTY INV',
    field: 'ftyPrice',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFty' },
  },
  {
    title: that.$l('table_label_eanCode') || 'EAN条码',
    field: 'eanCode',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    visible: that.hasVc,
  },
  {
    title: that.$l('INDEX.table_label_displaySize') || '产品尺寸',
    field: 'goodsSize',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySize' },
  },
  {
    title: that.$l('INDEX.table_label_displayUnit') || '单品包装',
    field: 'displayUnit',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayUnit' },
  },
  {
    title: that.$l('INDEX.table_label_goodsProperties') || '产品属性',
    field: 'goodsProperties',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_displayBox') || '纸箱',
    field: 'displayBox',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayBox' },
  },
  {
    title: that.$l('INDEX.table_label_materialInfo') || '材料信息',
    field: 'materialInfo',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_materialInfoEn') || '英文材料信息',
    field: 'materialInfoEn',
    width: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_displayHscodeName') || '报关品名',
    field: 'hscodeName',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayHscodeName' },
  },
  {
    title: that.$l('INDEX.table_label_displayDesignName') || '企划人员',
    field: 'designName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayDesignName' },
  },
]
